import inventoryAPI from '@/services/api/inventory'
import { ReasonType } from '@/utils/defines/ItemCode'

const InputReason = {
	namespaced: true,
	state: () => ({
		type: undefined,
		title: undefined,
		maxLength: undefined,
		reason: undefined,
	}),
	getters: {},
	mutations: {
		setType: (state, payload) => {
			state.type = payload
			switch (payload) {
				case ReasonType.ITEM_CONSUME:
				case ReasonType.ITEM_RETURN:
					state.title = '사용 사유'
					state.maxLength = 100
					break
				case ReasonType.ITEM_DELETE:
					state.title = '삭제 사유'
					state.maxLength = 100
					state.reason = ''
					break
				case ReasonType.ITEM_SUBDIVIDE:
				case ReasonType.ITEM_DISPOSAL:
					state.title = '폐기 사유'
					state.maxLength = 100
					state.reason = ''
					break
			}
		},
		setReason: (state, payload) => {
			state.reason = payload
		},
	},
	actions: {
		completeReason: async ({ state, commit }, payload) => {
			switch (state.type) {
				case ReasonType.ITEM_CONSUME: // 사용량 입력
				case ReasonType.ITEM_RETURN: // 반납
					break
				case ReasonType.ITEM_DELETE: // 삭제
					await inventoryAPI.deleteItem(
						payload.instId,
						payload.itemIds,
						state.reason
					)
					break
				case ReasonType.ITEM_SUBDIVIDE: // 소분
					await inventoryAPI.divideItem(payload.instId, {
						itemId: payload.itemId,
						isDispose: true,
						disposeMemo: state.reason,
						deriveItems: payload.deriveItems,
					})
					break
				case ReasonType.ITEM_DISPOSAL: // 폐기
					await inventoryAPI.disposeItem(payload.instId, {
						itemsId: payload.itemIds,
						memo: state.reason,
					})
					payload.this.$notify({
						type: 'common',
						text: '물품이 폐기되었습니다.',
					})
					break
			}
			if (state.type !== ReasonType.ITEM_RETURN) {
				await commit('setReason', '')
			}
		},
	},
}
export default InputReason
